import { Link } from "react-router-dom";

const friendLinks = [
  "国家电影局",
  "中国电影资料馆",
  "影视工业网",
  "豆瓣电影",
  "时光网",
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-foreground-950">
                <i className="ri-sun-line text-xl"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">
                向日葵视频
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-md">
              向日葵视频致力于为广大影视爱好者提供丰富的电影、电视剧及综艺节目内容。
              我们持续更新最新影视资讯，帮助你快速发现好片、了解行业动态，
              让每一次打开都充满期待。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              <a href="/#">内容导航</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-background-300 hover:text-primary-400 transition-colors">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-background-300 hover:text-primary-400 transition-colors">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="text-background-300 hover:text-primary-400 transition-colors">综艺频道</Link></li>
              <li><Link to="/news" className="text-background-300 hover:text-primary-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/search" className="text-background-300 hover:text-primary-400 transition-colors">搜索影片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              <a href="/#">友情链接</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {friendLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    className="text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2024 向日葵视频 · 本站内容为演示数据，仅供产品展示使用</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line"></i>
            <span>专注为影视爱好者提供优质观影导航</span>
          </p>
        </div>
      </div>
    </footer>
  );
}